import { render, staticRenderFns } from "./ColumnSimpleForm.vue?vue&type=template&id=2ff04a7e&scoped=true&"
import script from "./ColumnSimpleForm.vue?vue&type=script&lang=js&"
export * from "./ColumnSimpleForm.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSimpleForm.vue?vue&type=style&index=0&id=2ff04a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff04a7e",
  null
  
)

export default component.exports